import { render, staticRenderFns } from "./send-list.vue?vue&type=template&id=3fb1f50a"
import script from "./send-list.vue?vue&type=script&lang=js"
export * from "./send-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fb1f50a')) {
      api.createRecord('3fb1f50a', component.options)
    } else {
      api.reload('3fb1f50a', component.options)
    }
    module.hot.accept("./send-list.vue?vue&type=template&id=3fb1f50a", function () {
      api.rerender('3fb1f50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/send-list.vue"
export default component.exports